export const themes = {
    default: '',
    white: 'bg-white',
};
//# sourceMappingURL=themes.js.map